import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { store } from './services';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <AuthProvider>
        <Provider store={store}>
            <App />
        </Provider>
    </AuthProvider>,
);
